import { useMemo, useState } from 'react'
import { CardInfo, getCDNUrl } from '@shared'

import { Button } from '../Button'
import styles from './DonatePopup.module.scss'
import { DonateWithSlider } from './DonateWithSlider/DonateWithSlider'
import { useTranslation } from 'react-i18next'

interface PopupProps {
  onClose: () => void
}

export const DonatePopup = ({ onClose }: PopupProps) => {
  const [selectedCur, setSelectedCur] = useState<'' | 'TON' | 'XTR'>('');
  const { t } = useTranslation()
  const cardInfo = useMemo(() => {
    return {
      url: getCDNUrl("/assets/donate/Combo.png"),
      effects: {},
      title: "Donate",
      description: t('shop.donate.description')
    }
  }, [t])

  if (selectedCur) {
    return <DonateWithSlider cur={selectedCur} onClose={onClose} />
  }
  return (
    <CardInfo
      url={cardInfo.url}
      effects={cardInfo.effects}
      onClose={onClose}
      title={cardInfo.title}
      description={cardInfo.description}
    >
      <div className={styles.buttons}>
        <Button
          icon="crypto"
          onClick={() => {
            setSelectedCur('TON')
          }}
        >
          Donate crypto
        </Button>
        <Button
          icon="buy"
          onClick={() => {
            setSelectedCur('XTR')
          }}
        >
          Donate stars
        </Button>
      </div>
    </CardInfo>
  )
}
